import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL + ""; // URL для получения данных
const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

export default {
    namespaced: true,
    state: {
        categories: [],
        mainCategory: [],
        settings: [],
        settingsLoaded: false
    },
    mutations: {
        SET_CATEGORY(state, payload) {
            if (payload) {
                if (state.categories && state.categories.some(cat => cat.category_name === payload[0].category_name)) {
                    return
                }
                state.categories.push(payload[0]);
            }
        },
        SET_CATEGORIES(state, payload) {
            state.categories = payload;
        },

        SET_MAIN_CATEGORY(state, payload) {
            state.mainCategory = payload;
        },

        SET_CATEGORY_ITEMS(state, payload) {
            if (state.categories.length > 0) {
                for (let cat of state.categories) {
                    if (cat['category_name'] === payload.categoryName) {
                        cat.items = payload.items
                    }
                }
            }
        },

        SET_SETTINGS(state, payload) {
            state.settings = payload;
            state.settingsLoaded = true;
        }
    },
    actions: {
        async fetchCategories({ commit }) {
            try {
                let transformedData;

                const response = await axios.get(
                    `${baseUrl}/categories/getCategories`,
                    {
                        ...config
                    }
                );
                try {
                    transformedData = response.data
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_CATEGORIES', transformedData);
            } catch (error) {
                console.error(error);
            }
        },

        async fetchCategoryByName({ commit }, name) {
            try {
                const response = await axios.get(
                    `${baseUrl}/categories/getCategoryByName?categoryName=${name}`,
                    {
                        ...config
                    }
                );
                commit('SET_CATEGORY', response.data);
            } catch (error) {
                console.error(error);
            }
        },

        async fetchMainCategory({ commit }) {
            try {
                const response = await axios.get(
                    `${baseUrl}/categories/getMainCategory`,
                    {
                        ...config
                    }
                );
                commit('SET_MAIN_CATEGORY', response.data);
            } catch (error) {
                console.error(error);
            }
        },

        async fetchCategoryItems({ state, commit }) {
            try {
                for (let cat of state.categories) {
                    const response = await axios.get(
                        `${baseUrl}/categories/getCategoryItems?categoryName=${cat['category_name']}`,
                        {
                            ...config
                        }
                    );
                    commit('SET_CATEGORY_ITEMS', {categoryName: cat['category_name'], items: response.data});
                }
            } catch (error) {
                console.error(error);
            }
        },

        async fetchSiteSettings({ state, commit }) {
            if (state.settingsLoaded) {
                return state.settings;
            }
            try {
                const response = await axios.get(
                    `${baseUrl}/settings/getSiteSettings`,
                    {
                        ...config
                    }
                );
                commit('SET_SETTINGS', response.data);
            } catch (error) {
                console.error(error);
            }
        },

        async updateSiteSettings({ state, commit }, { key, value }) {
            try {
                const response = await axios.patch(
                    `${baseUrl}/settings/updateSiteSettings`,
                    {
                        key: key,
                        value: value
                    },
                    {
                        ...config
                    }
                );

                const updatedSetting = response.data;

                const settings = state.settings.map(setting =>
                    setting.key === updatedSetting.key
                        ? updatedSetting
                        : setting
                );

                commit('SET_SETTINGS', settings);

                return updatedSetting;

            } catch (error) {
                console.error(error);
                throw error;
            }
        }
    }
}